import type { CSSProperties } from 'react'

/** Largura dinâmica para barras cf3 (--cf3-bar-w). */
export function barFillStyle(pct: number): CSSProperties {
  return { '--cf3-bar-w': `${pct}%` } as CSSProperties
}

/** Altura dinâmica para barras verticais cf3 (--cf3-bar-h). */
export function barHeightStyle(px: number): CSSProperties {
  return { '--cf3-bar-h': `${px}px` } as CSSProperties
}

/** Posição e largura para segmentos cf3 (--cf3-bar-l, --cf3-bar-w). */
export function barSegmentStyle(leftPct: number, widthPct: number): CSSProperties {
  return { '--cf3-bar-l': `${leftPct}%`, '--cf3-bar-w': `${widthPct}%` } as CSSProperties
}

/** Posição top dinâmica cf3 (--cf3-top-pct). */
export function barTopStyle(pct: number): CSSProperties {
  return { '--cf3-top-pct': `${pct}%` } as CSSProperties
}
